import axios from 'axios'

const signUp = (signUpData, cb, errorCb) => {
  return axios
  .post(`${process.env.VUE_APP_API_ENDPOINT}/api/signup`, signUpData)
  .then(({ data }) => {
    if (data.value.success) {
      cb(data);
      return true;
    } else {
      return false;
    }
  })
  .catch(error => {
    errorCb(error)
    return false;
  })
};

// This function is called from the login action
// in the users module. If returns the status of the
// authentication request. If success, it puts the
// user data in the store.
const login = (credentials, cb, errorCb) => {

  return axios
  .post(`${process.env.VUE_APP_API_ENDPOINT}/api/login`, credentials)
  .then(({ data }) => {
    if (data.value.success) {
      cb(data);
      return true;
    } else {
      return false;
    }
  })
  .catch(error => {
    errorCb(error)
    return false;
  })
};

const forgetPassword = (userData, cb, errorCb) => {
  return axios
  .post(`${process.env.VUE_APP_API_ENDPOINT}/api/requestForgetPassword`, userData)
  .then(({ data }) => {
    if (data.value.success) {
      cb(data);
      return true;
    } else {
      return false;
    }
  })
  .catch(error => {
    errorCb(error)
    return false;
  })
};

const resetPassword = (userData, cb, errorCb) => {
  
  const data = {
    'password': userData.password
  };
  const headers = {
    "x-access-token": userData.id
  };

  return axios
  .post(`${process.env.VUE_APP_API_ENDPOINT}/api/password/reset`, data, {
    headers: headers
  })
  .then(({ data }) => {
    if (data.value.success) {
      cb(data);
      return true;
    } else {
      return false;
    }
  })
  .catch(error => {
    errorCb(error)
    return false;
  })
};

const logout = () => {

};

const customerUpdateProfile = (updateProfileData) => {
  const accountId = updateProfileData.value.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, updateProfileData)
    .then(({ data }) => {
      console.log(`[api] - customerUpdateProfile - success`);
      return data;
    })
    .catch(error => {
      throw error
    })
  };

const customerUpdateMessagingKeys = (updateMessagingKeysData) => {
  const accountId = updateMessagingKeysData.value.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, updateMessagingKeysData)
    .then(({ data }) => {
      console.log(`[api] - customerUpdateMessagingKeys - success`);
      return data;
    })
    .catch(error => {
      throw error
    })
};

const customerCreateNewUser = (createNewUserData) => {
  const accountId = createNewUserData.value.data.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, createNewUserData)
    .then(({ data }) => {
      console.log(`[api] - customerCreateNewUser - success`);
      return data;
    })
    .catch(error => {
      throw error
    })
  };

const customerUpdateCrmConfig = (updateCrmConfigData) => {
  const accountId = updateCrmConfigData.value.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, updateCrmConfigData)
    .then(({data}) => {
      console.log(`[api] - customerUpdateCrmConfig - success`);
      return data;
    })
    .catch(error => {
      throw error
    });
};

const customerUpdateWconfig = (saveEntityData) => {
  const accountId = saveEntityData.value.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, saveEntityData)
    .then(({ data }) => {
      console.log(`[api] - customerUpdateWconfig - success`);
      return data;
    })
    .catch(error => {
      throw error
    })
  };

const customerUpdateLanguageConfig = (updateLanguageData) => {
  const accountId = updateLanguageData.value.accountId;
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/account/${accountId}/customerOps`

  return axios
    .post(url, updateLanguageData)
    .then(({ data }) => {
      console.log(`[api] - customerUpdateLanguageConfig - success`);
      return data;
    })
    .catch(error => {
      throw error
    });
};

const health = (requestObj) => {
  const url = `${process.env.VUE_APP_API_ENDPOINT}/api/health`

  return axios
    .get(url, requestObj)
    .then(({ data }) => {
      console.log(`[api] - health check - success`);
      return data;
    })
    .catch(error => {
      throw error
    });
};

const verifyAccountID = (accountId) => {
  const url = `https://api.liveperson.net/api/account/${accountId}/service/baseURI.json?version=1.0`;

  // When sending requests to cross domains please request headers
  sessionStorage.setItem('cross-domain-request', true);

  return axios
    .get(url)
    .then(({ data }) => {
      sessionStorage.removeItem('cross-domain-request')
      if (data.baseURIs.length) {
        return true
      }
      return false
    })
    .catch(error => {
      sessionStorage.removeItem('cross-domain-request')
      throw error
    });
}; 

export default {
  signUp,
  login,
  forgetPassword,
  resetPassword,
  logout,
  customerUpdateProfile,
  customerUpdateMessagingKeys,
  customerCreateNewUser,
  customerUpdateCrmConfig,
  customerUpdateWconfig,
  customerUpdateLanguageConfig,
  health,
  verifyAccountID
}